<div class="shadow-md bg-white w-full flex flex-col max-h-full">
  <div class="flex flex-row justify-between items-center p-8 bg-primary-600 text-contrast overflow-hidden rounded-t-md">
    <h2 class="m-0 font-bold">
      @if (id()) {
        {{ { key: 'editAccompanyingPerson' } | i18n }}
      } @else {
        {{ { key: 'recordAccompanyingPerson' } | i18n }}
      }
    </h2>

    <button (click)="close()">
      <ng-icon name="heroXMark" class="h-5 w-5 flex-shrink-0" size="24px"></ng-icon>
    </button>
  </div>

  <div class="p-8 overflow-auto">
    @if (companion.isLoading()) {
      <div class="w-full h-96">
        <app-loading></app-loading>
      </div>
    } @else if (companion.error()) {
      <div class="text-red-500">{{ { key: 'errorLoading' } | i18n }}</div>
    } @else {
      <form class="grid grid-cols-1 gap-4 overflow-auto" [formGroup]="companionForm">
        <div class="grid grid-cols-1 gap-4" formGroupName="name">
          <div class="flex flex-col gap-2">
            <label class="text-sm font-bold" for="salutation">{{ { key: 'salutation' } | i18n }}</label>
            <select
              id="salutation"
              name="salutation"
              class="mt-2 block w-full border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-primary-600 sm:text-sm sm:leading-6"
              formControlName="salutation"
            >
              @for (item of salutationRows; track item._id) {
                <option [value]="item._id">{{ item.displayValue }}</option>
              }
            </select>
          </div>

          <div class="grid grid-cols-2 gap-4">
            <div class="flex flex-col gap-2">
              <label class="text-sm font-bold" for="given-name">{{ { key: 'givenName' } | i18n }}*</label>
              <input
                class="block w-full border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
                id="given-name"
                type="text"
                formControlName="givenName"
              />
              <!-- <app-input formCControlName="givenName"></app-input> -->
            </div>
            <div class="flex flex-col gap-2">
              <label class="text-sm font-bold" for="family-name">{{ { key: 'familyName' } | i18n }}*</label>
              <input
                class="block w-full border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
                id="family-name"
                type="text"
                formControlName="familyName"
              />
            </div>
          </div>
        </div>

        <div class="flex flex-col gap-4" formGroupName="address">
          <div class="flex flex-col gap-2">
            <label class="text-sm font-bold" for="street">{{ { key: 'street' } | i18n }}*</label>
            <input
              class="block w-full border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
              id="street"
              type="text"
              formControlName="street"
            />
          </div>

          <div class="grid grid-cols-3 gap-4">
            <div class="flex flex-col gap-2 col-span-1">
              <label class="text-sm font-bold" for="postalCode">{{ { key: 'postalCode' } | i18n }}*</label>
              <input
                class="block w-full border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
                id="postalCode"
                type="text"
                formControlName="postalCode"
              />
            </div>
            <div class="flex flex-col gap-2 col-span-2">
              <label class="text-sm font-bold" for="locality">{{ { key: 'locality' } | i18n }}*</label>
              <input
                class="block w-full border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
                id="locality"
                type="text"
                formControlName="locality"
              />
            </div>
          </div>
        </div>

        <div class="flex flex-col gap-2">
          <label class="text-sm font-bold" for="mobile">{{ { key: 'mobile' } | i18n }}</label>
          <input
            class="block w-full border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
            id="mobile"
            type="text"
            formControlName="mobile"
          />
        </div>

        <div class="flex flex-col gap-2">
          <label class="text-sm font-bold" for="eMail">{{ { key: 'eMail' } | i18n }}</label>
          <input
            class="block w-full border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
            id="eMail"
            type="text"
            formControlName="eMail"
          />
        </div>

        <div class="mt-2 text-xs">* {{ { key: 'mandatoryFields' } | i18n }}</div>

        <div class="mt-4 grid grid-cols-1 gap-4">
          @if (companionForm.dirty && companionForm.status === 'VALID') {
            <button
              class="w-full items-center justify-center border border-transparent py-2 px-4 text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-600 focus:ring-offset-2"
              (click)="save()"
            >
              {{ { key: 'save' } | i18n }}
            </button>
          } @else {
            <button
              class="w-full items-center justify-center border border-transparent py-2 px-4 text-sm font-medium text-white bg-gray-300 cursor-not-allowed"
            >
              {{ { key: 'save' } | i18n }}
            </button>
          }
          @if (companion.value()?._id) {
            <button
              class="w-full items-center justify-center border border-transparent py-2 px-4 text-sm font-medium text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-600 focus:ring-offset-2"
              (click)="remove()"
            >
              {{ { key: 'delete' } | i18n }}
            </button>
          }
        </div>
      </form>
    }
  </div>
</div>
